import React, { useEffect, useState } from 'react';
import { Table,Card,Spin} from 'antd';
import {  DownloadOutlined } from '@ant-design/icons';
import utils from 'cl-library/dist/utils/index'
import MoreTableData from './moreTableData';
import { CSVLink } from "react-csv";
import RmName from "../../RmName.json";
const header=[
{label:"Date",key:"Date"},
{label:(RmName.nameCode),key:"RM_code"},
{label:"Token_no",key:"Token_no"},
{label:"Math_starting_ws",key:"Math_starting_ws"},
{label:"Math_last_ws",key:"Math_last_ws"},
{label:"English_starting_ws",key:"English_starting_ws"},
{label:"English_last_ws",key:"English_last_ws"},
];

const TableData = ({data}) =>{
let date= new Date();
const today = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
const time=`${date.getHours()}:${date.getMinutes()}`
 
  let csvRport={
    filename:`"Study plan"+${today}+${time}`,
    headers:header,
    data:data
}
  
    const [loading, setLoading] = useState(true);  
    // // eslint-disable-next-line
    const [tableData,setTableData]=useState(data);
    // eslint-disable-next-line
    
   
    
    const columns = [
          {
            title: "Date",
            dataIndex: "Date",
            key: "Date",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'Date')
          },
          {
            title: (RmName.nameCode),
            dataIndex: "RM_code",
            key: "RM_code",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'RM_code')
          },
          {
            title: "Token No",
            dataIndex: "Token_no",
            key: "Token_no",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'Token_no')
          },
          {
            title: "Math starting ws",
            dataIndex: "Math_starting_ws",
            key: "Math_starting_ws",
            fixed: "left",            
            sorter: (a, b) => utils.antdTableSorter(a, b, 'Math_starting_ws')
          },
          {
            title: "Math last ws",
            dataIndex: "Math_last_ws",
            key: "Math_last_ws",
            fixed: "left",            
            sorter: (a, b) => utils.antdTableSorter(a, b, 'Math_last_ws')
          },
          {
            title: "English starting ws",
            dataIndex: "English_starting_ws",
            key: "English_starting_ws",
            fixed: "left",            
            sorter: (a, b) => utils.antdTableSorter(a, b, 'English_starting_ws')
          },
          {
            title: "English last ws",
            dataIndex: "English_last_ws",
            key: "English_last_ws",
            fixed: "left",            
            sorter: (a, b) => utils.antdTableSorter(a, b, 'English_last_ws')
          },  
           
    ];
 
    useEffect(()=>{
      async function fatchData(){
        data.map((obj,index)=>{obj.index=index})
        setTableData(data);
        setLoading(false)
      }
      fatchData();
      // eslint-disable-next-line 
    },[data])

  

    
    return (
      loading ? (<Spin tip='loading'></Spin>) :
        <>      
            <Card title="Active Students" 
                  style={{ 'fontSize': '5px' }} 
                  extra={ 
                        <CSVLink {...csvRport}>
                         <DownloadOutlined style={{ 'fontSize': 30 }}/>
                        </CSVLink>
                      }> 
                  <Table xs={24} sm={50} md={50}
                      columns={columns} 
                      dataSource={tableData} 
                      rowKey='index'  
                      expandable={{ expandedRowRender:record=>{
                        return <MoreTableData record={record}/>;
                      } }} 
                    />
                              
              </Card>
            
        </>
    )
}

export default TableData
